<template>
  <div class="charts-overview">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">USTED ESTA AQUI</li>
      <li class="breadcrumb-item active">Resultados Cuadro de Cumplimiento</li>
    </ol>
    <h1 class="page-title">Cuadro de Cumplimiento - <span class="fw-semi-bold">Totalizado Agencias</span></h1>
    <div>

    <b-row>

        <b-col lg="6" sm="6" xs="12">
          <div class="vx-col w-full">
              <Widget
            title="<h5>  <span class='fw-semi-bold'>NOTA POR ASPECTO A EVALUAR</span></h5>"
            close collapse customHeader>

             <div id="extra-component-echarts-demo">
    
                <div class="vx-row match-height">
                    
                        <div class="vx-col w-full">
                            <echarts-pie-chart></echarts-pie-chart>
                        </div>
                    
                    </div>
                </div>
         
          </Widget>
          </div>
      </b-col>
      <b-col lg="6" sm="6" xs="12">
      <Widget
            title="<h5> Total <span class='fw-semi-bold'>Puntuación</span></h5>"
            close collapse customHeader>

            <h2>90</h2>
            <div>
              <div class="text-center" ref="morrisDonutChart" :style="{ height: '282px' }" />
              <p class="fs-mini text-muted">
                Para un total de  <code>100</code>
                puntos.
              </p>
            </div>
            <div class="d-flex border-top">
                <div class="w-50 border-right p-3 px-4">
                <div class="d-flex justify-content-between align-items-center"><h6>20</h6>
                    
                </div>
                <p class="text-muted mb-0 mr">
                    <small>Agencias evaluadas</small>
                </p>
                </div>
                <div class="w-50 p-3 px-4">
                <div class="d-flex justify-content-between align-items-center"><h6>6</h6>
                   
                </div>
                <p class="text-muted mb-0 mr">
                    <small>Aspectos Evaluados</small>
                </p>
                </div>
            </div>
          </Widget>
      </b-col>
      
    </b-row>

     <b-row>
      
        <b-col  class="vx-col w-full" >
            <div>
              <Widget
            title="<h5>  <span class='fw-semi-bold'>Resultado por Aspecto</span></h5>"
            close collapse customHeader>

             <div id="extra-component-echarts-demo">
    
                <div >
                    <div >
                        <echarts-bar-chart></echarts-bar-chart>
                    </div>
                      
                    </div>
                </div>
         
          </Widget>
          </div>
        </b-col>
     
      </b-row>

    
     <b-row>
      
        <b-col  class="vx-col w-full" >
            <div>
              <Widget
            title="<h5>  <span class='fw-semi-bold'>Resultado por Agencia</span></h5>"
            close collapse customHeader>

             <div >
    
                <div >
                   <div>
                            <e-charts style="width:1300px" :options="bar" ref="bar" theme="ovilia-green" auto-resize />
                        </div>
                                   
                    
                    </div>
                </div>
         
          </Widget>
          </div>
        </b-col>
     
      </b-row>

      
      
    
    </div>
  </div>
</template>

<script>

import EchartsPieChart from './EchartsPieChart.vue'
import EchartsBarChart from './EchartsBarChart.vue'
import EchartsBarChartAgency from './EchartsBarChartAgency.vue'

import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'

import $ from 'jquery';
/* eslint-disable */
import 'imports-loader?jQuery=jquery,this=>window!easy-pie-chart/dist/jquery.easypiechart.js';
import 'imports-loader?jQuery=jquery,this=>window!jquery-sparkline';
import 'imports-loader?jQuery=jquery,this=>window!webpack-raphael/raphael';
import 'imports-loader?jQuery=jquery,this=>window!govpredict-morris/morris';
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.resize';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.time';
import 'imports-loader?jQuery=jquery,this=>window!jquery.flot.animator/jquery.flot.animator';
import 'imports-loader?jQuery=jquery,this=>window!jquery.flot-orderBars/js/jquery.flot.orderBars';
/* eslint-enable */
import Widget from '@/components/Widget/Widget';
import d3 from 'd3';
import nv from 'nvd3';
import Rickshaw from 'rickshaw';
import FlotBars from './Flot/charts/BarsChart';


const { Morris } = window;

export default {
    data() {
        return {
            bar: {
                legend: {},
                tooltip: {},
                dataset: {
                    
                    source: [
                        ['Comparativo', 'Agencias'],
                        ['AVIA', 90],
                        ['ESQUIPULAS', 85],
                        ['XELA', 90],
                        ['BLUE PREMIUM', 95],
                        ['SS ARKADIA', 100],
                        ['ZONA UNO ', 80],
                        ['PETAPA ', 85],
                        ['AMERICAS ', 85]
                    ]
                },
                // Declare X axis, which is a category axis, mapping
                // to the first column by default.
                xAxis: { type: 'category' },
                // Declare Y axis, which is a value axis.
                yAxis: {},
                // Declare several series, each of them mapped to a
                // column of the dataset by default.
                series: [{ type: 'bar' }]

            },
        }
    },
    
  name: 'Charts',
  components: { Widget, FlotBars, EchartsPieChart,EchartsBarChart, EchartsBarChartAgency,ECharts },
  methods: {
    onResize() {

      this.initMorrisDonutCharts();
  
    },
  
    initMorrisDonutCharts() {
      $(this.$refs.morrisDonutChart).html('');
      Morris.Donut({
        element: this.$refs.morrisDonutChart,
        colors: ['#39A305', '#B4FD00' ],
        data: [
          { label: 'Cumplimiento', value: 90 },
          { label: 'No cumple', value: 10 },
        ],
      });
    },
  
  },
  mounted() {
    this.initMorrisDonutCharts();
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style src="./CDCCharts.scss" lang="scss" />
